import React, { useEffect, useState } from "react";
import styles from "./style.module.css";

interface IProps {
  placeHolder?: string;
  searchText: string;
  setSearchText: (text: string) => void;
  status?: boolean;
}

export default function SearchBox({
  placeHolder,
  searchText,
  setSearchText,
  status,
}: IProps) {
  const [inputValue, setInputValue] = useState(searchText || "");
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
    if (event.target.value === "") {
      setSearchText("");
    }
  };

  const isSearch =
    inputValue.length > 0 &&
    (searchText.length === 0 || inputValue !== searchText);

  const handleKeyEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      e.key === "Enter" &&
      inputValue.length > 0 &&
      (searchText.length === 0 || inputValue !== searchText)
    ) {
      handleButtonClick();
    }
  };
  const handleButtonClick = () => {
    // if (isSearch && inputValue.length === 0) {
    //   return toast.error("검색어를 입력해주세요");
    // }

    if (isSearch) {
      setSearchText(inputValue);
    } else {
      setInputValue("");
      setSearchText("");
    }
  };
  useEffect(() => {
    if (searchText && status) {
      setSearchText(inputValue);
    }
  }, []);

  return (
    <div>
      <div className={styles.searchBox}>
        <input
          type="text"
          onChange={handleInputChange}
          value={inputValue}
          placeholder={placeHolder}
          onKeyDown={handleKeyEnter}
        />
        <button
          type="button"
          onClick={handleButtonClick}
          style={{ cursor: "pointer" }}
        >
          {isSearch ? "검색" : "취소"}
        </button>
      </div>
    </div>
  );
}
